function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-556.989 -89.837)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M566.124,108.061h-8.012c-.862,0-1.126-.272-1.123-1.144a9.469,9.469,0,0,1,8.228-9.3,9.125,9.125,0,0,1,9.515,6.265,15.77,15.77,0,0,1,.558,3.195c.077.668-.3.985-.991.986Q570.211,108.065,566.124,108.061Zm7.292-1.765c.082-3.456-3.495-6.95-7.158-6.954a7.437,7.437,0,0,0-7.378,6.954Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.569,94.4A4.579,4.579,0,1,1,566.1,99,4.562,4.562,0,0,1,561.569,94.4Zm4.571-2.82a2.835,2.835,0,1,0,2.841,2.841A2.858,2.858,0,0,0,566.14,91.583Z"
}));

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2cbbdb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.311,
    height: 18.225,
    viewBox: "0 0 18.311 18.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3a5b1dfc6f82cede4592b882ea5d1745.svg";
export { ForwardRef as ReactComponent };